import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Input } from 'reactstrap'
import { onChangeNote, saveNote, fetchCourseNotes } from 'store/Course/actions'

function Notes({ language }) {
  const [buttonText, setButtonText] = useState(
    language?.general?.save || 'Save'
  )

  const dispatch = useDispatch()
  const course = useSelector((state) => state.courses)
  const { courseNote, course_id } = course

  useEffect(() => {
    dispatch(fetchCourseNotes())
  }, [dispatch])

  const handleChange = (e) => {
    const newNote = e.target.value
    dispatch(onChangeNote(newNote)) // Update the Redux state with the new note
    setButtonText('Save changes') // Update button text to indicate changes
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setButtonText('Saved') // Update button text while saving
    dispatch(saveNote(courseNote, course_id))
  }

  return (
    <div>
      <div className='tl-course-promotion'>
        <form onSubmit={handleSubmit}>
          <label
            className='form-control-label'
            htmlFor='exampleFormControlTextarea3'
          >
            {language?.courses?.leave_notes}
          </label>
          <Input
            className='shadow-sm'
            id='exampleFormControlTextarea3'
            value={courseNote?.note} // Ensure the value is controlled
            resize='none'
            rows='5'
            type='textarea'
            onChange={handleChange} // Update note and button text on change
            placeholder='Write a note'
          />
          <div className='text-right mt-2'>
            <Button className='btn px-3 btn-info' type='submit' size='sm'>
              {buttonText}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Notes
